import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { PublicTopNav } from "./common/layout/TopNav";
import Register from "./Register/Register";
import SignIn from "./SignIn/SignIn";
import VendorPartnership from "./VendorPartnership/VendorPartnership";
import Pending from './VendorProfile/Pending';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<Register />} />
        <Route path="/vendor-partnership" element={
          <div>
            <PublicTopNav />
            <VendorPartnership />
          </div>
        } />
        <Route path="/vendor/*" element={
          <div>
            <Pending />
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
